export default "__VITE_ASSET__f1ultBx7__"